<template>
    <div class="radar_pulse" :class="classes">
        <div class="ring"/>
        <div class="ring"/>
        <div class="ring"/>
    </div>
</template>

<script>
export default {
    props: ['grey', 'yellow', 'reverse'],
    computed: {
        classes() {
            return {
                'yellow': this.yellow != undefined,
                'grey': this.grey != undefined,
                'reverse': this.reverse != undefined,
            }
        },
    },
}
</script>

<style lang="scss" scoped>

$dims: 10rem;

.radar_pulse {
    height: $dims;
    width: $dims;
    position: absolute;
    transform: translate(-50%, -50%);
}

.ring {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    border: 1px solid $colour__accent1;
    transform: scale(.5);
    opacity: 0;
    animation: pulse 1.8s linear infinite;
    &:nth-child(2) { animation-delay: 0.6s }
    &:nth-child(3) { animation-delay: 1.2s }
    .yellow & {
        border-color: $colour__accent1;
    }
    .grey & {
        border-color: $colour__primary1;
    }
    .reverse & {
        animation-direction: reverse;
    }
}

@keyframes pulse {
    0% {
        transform: scale(.5);
        opacity: 0;
    }
    50% {
        transform: scale(1.2);
        opacity: 1;
    }
    100% {
        transform: scale(1.9);
        opacity: 0;
    }
}
</style>